const initialState = {
  message: {
    error: null,
    success: null,
  },
  loading: false,
};

const VerifyOTPReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "VERIFY_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "VERIFY_SUCCESS":
      return {
        ...state,
        loading: false,
        message: {
          error: null,
          success: payload,
        },
      };

    case "VERIFY_FAILURE":
      return {
        ...state,
        loading: false,
        message: {
          error: payload,
          success: null,
        },
      };

    default:
      return state;
  }
};

export default VerifyOTPReducer;
